var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMovie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "movie-line 1",
    clipPath: "url(#clip0_13098_11832)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.6665 3.3275C1.66803 3.10865 1.75559 2.89918 1.91026 2.74435C2.06494 2.58951 2.27432 2.50175 2.49317 2.5H17.5065C17.9632 2.5 18.3332 2.87083 18.3332 3.3275V16.6725C18.3316 16.8914 18.2441 17.1008 18.0894 17.2557C17.9347 17.4105 17.7254 17.4983 17.5065 17.5H2.49317C2.27385 17.4998 2.06358 17.4125 1.90858 17.2573C1.75357 17.1022 1.6665 16.8918 1.6665 16.6725V3.3275ZM3.33317 4.16667V15.8333H16.6665V4.16667H3.33317ZM8.8515 7.0125L12.9173 9.7225C12.9631 9.75293 13.0006 9.79418 13.0265 9.84259C13.0524 9.89101 13.066 9.94508 13.066 10C13.066 10.0549 13.0524 10.109 13.0265 10.1574C13.0006 10.2058 12.9631 10.2471 12.9173 10.2775L8.85067 12.9875C8.80053 13.0207 8.74232 13.0398 8.68223 13.0426C8.62214 13.0455 8.5624 13.032 8.50934 13.0036C8.45629 12.9753 8.4119 12.9331 8.38089 12.8815C8.34987 12.83 8.33338 12.771 8.33317 12.7108V7.28917C8.33328 7.22888 8.34974 7.16974 8.3808 7.11807C8.41186 7.06639 8.45635 7.02411 8.50954 6.99572C8.56273 6.96733 8.62262 6.9539 8.68284 6.95685C8.74306 6.95981 8.80135 6.97904 8.8515 7.0125Z",
    fill: "#999999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13098_11832"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovie);
export default __webpack_public_path__ + "static/media/movie.60ae5a5fd7891b1e1c17d0835e2420d7.svg";
export { ForwardRef as ReactComponent };